export default __webpack_public_path__ + "64480055c388abfed2a65b371f667046.svg";